<template>
  <div class="page password-change">
    <div class="page-inner">
      <PasswordChangeForm ref="refUserForm" :userData="userData" />
    </div>
    <Footer />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import PasswordChangeForm from "../signUp/comp/userForm/PasswordChangeForm.vue";
import Footer from "../commonComp/Footer.vue";
const modelService = require("@/utils/dataModel.js");
export default {
  components: {
    PasswordChangeForm,
    Footer
  },
  data() {
    return {
      userData: modelService.userModel(),
    };
  },
  mounted() {
    this.userData = this.meInfo;
    this.userData.password = "";
    if (this.isDev) {
      // this.userData.currentPassword = "123456789001!";
      // this.userData.password = "123456789!";
      // this.userData.rePassword = "123456789!";
    }
  },
  computed: {
    ...mapGetters(["isDev", "meInfo"]),
  },
  methods: {},
};
</script>
<style lang="scss">
.password-change {
  &.page {
    .page-inner {
      padding: 20px;
      // height: calc(100svh - 200px);

      .v-btn:not(.v-btn--round).v-size--x-large {
        margin-top: 30px;
      }
    }
  }

}
</style>
